<!-- **** --------------------------------------------------------------------------
	SHARED SCRIPT
-------------------------------------------------------------------------- **** -->
<script lang="ts">
    import { computed, onMounted } from 'vue';
    import * as NodeAssets from './NodeAssets';
    import { NodeType } from '../../Enums';

    const assets: { [key: string]: Element | unknown } = NodeAssets;
    const { NodeFrame, NodeIcon } = NodeAssets;

    // this is mostly for debugging, otherwise components are Anonymous
    const component = {
        name: 'NodeTemplate',
    };
    export default {
        name: component.name,
    };
</script>

<!-- **** --------------------------------------------------------------------------
	SCRIPT
-------------------------------------------------------------------------- **** -->
<script lang="ts" setup>
    const props = withDefaults(
            defineProps<{
                id: number | string;
                type?: NodeType;
                frame?: number;
                frameColor?: { h: number; s: number; l: number };
                icon?: number;
                iconColor?: { h: number; s: number; l: number };
                height?: number;
                width?: number;
            }>(),
            {
                height: 100,
                width: 100,
            }
        ),
        viewbox = props.type === NodeType.Page ? `0 0 ${props.width} ${props.height}` : `0 0 100 100`;

    const iconTransform = computed(() =>
        [NodeFrame.RoundedSquare, NodeFrame.Polygon8, NodeFrame.Circle].indexOf(props.frame!) !== -1
            ? 'scale(1.06)'
            : NodeFrame.RoundedRect === props.frame!
              ? 'translate(-41 0) scale(.19)'
              : 'scale(1)'
    );
</script>

<!-- **** --------------------------------------------------------------------------
	TEMPLATE
-------------------------------------------------------------------------- **** -->
<template>
    <div
        class="node-wrapper"
        v-once
        :key="id"
        :style="[
            !frameColor
                ? ''
                : [
                      `--clr-node-icon-shadow: hsla(${frameColor.h}, ${frameColor.s - 25}%, ${frameColor.l - 25}%,.15)`,
                      `--clr-node-inverted-frame: hsl(${0}, ${0}%, ${frameColor.l < 30 ? 100 : 0}%)`,
                  ],
            !iconColor
                ? ''
                : [
                      `--clr-node-icon-secondary: hsl(${(iconColor.h + 100) % 360}, ${iconColor.s + 25}%, ${(iconColor.l + 49) % 80}%)`,
                      `--clr-node-inverted-primary: hsl(${0}, ${0}%, ${(iconColor.l + 49) % 100}%)`,
                  ],
        ]">
        <svg
            class="node-vector"
            xmlns="http://www.w3.org/2000/svg"
            :viewBox="viewbox"
            height="100%"
            width="100%"
            :style="`
                                                --template-frame-clr: hsl(${frameColor?.h}, ${frameColor?.s}%, ${frameColor?.l}%);
                                                --template-icon-clr: hsl(${iconColor?.h}, ${iconColor?.s}%, ${iconColor?.l}%);
                                             `">
            <defs>
                <clipPath v-if="frame" :id="`cp${NodeFrame[frame]}`">
                    <component :id="NodeFrame[frame]" :is="assets[NodeFrame[frame]]"></component>
                </clipPath>
            </defs>

            <!-- <use v-if="frame" :href="`#${ NodeFrame[frame] }`" class="node-shadow"
                        :transform="`scale(${ frame === NodeFrame.RoundedRect ? '.75' : '.9'})`"
                        x="2"
                        y="5"
                        opacity=".4"
                        filter="url(#gausBlur)"
                        ></use> -->
            <g :style="frame ? `clip-path: url(#cp${NodeFrame[frame]})` : ''">
                <rect v-if="frame && frame === NodeFrame.RoundedRect" x="17" width="83" height="100%" fill="hsl(180, 100%, 14%)" class="rrFrame"></rect>
                <rect
                    v-if="frame"
                    width="100"
                    height="100%"
                    class="node-frame pe-visible"
                    :transform="frame === NodeFrame.RoundedRect ? 'translate(-2, 40) scale(.2)' : ''"></rect>
                {{ icon }}
                <component v-if="icon" :transform="iconTransform" :is="assets[NodeIcon[icon]]" :class="'node-icon'"></component>
            </g>
        </svg>
        <!-- <div class="node-shadow"></div> -->
    </div>
</template>

<!-- **** --------------------------------------------------------------------------
	STYLES
-------------------------------------------------------------------------- **** -->
<style>
    .node-wrapper {
        display: block;
        position: relative;
        height: 100%;
        width: 100%;
    }

    .node-wrapper.frame-offset-rect svg {
        position: absolute;
        top: -200%;
    }

    .node-vector,
    .node-shadow {
        pointer-events: none;
    }

    .node-frame {
        position: absolute;
        fill: var(--template-frame-clr);
    }

    /* .node-shadow { */
    /* display: block;
   position: absolute;
   top: 0;
   right: 0;
   bottom: 0;
   left: 0;
   margin: auto;
   height: 70%;
   width: 70%; */
    /* transform-origin: center; */
    /* box-shadow: 10px 15px 20px -2px black; */
    /* background-color: black;
   filter:blur(20px);
   z-index: -1; */
    /* will-change: contents */
    /* } */
    .node-icon {
        transform-origin: center;
        fill: var(--template-icon-clr);
    }

    .node-icon-shadow {
        fill: var(--clr-node-icon-shadow);
    }

    .node-fill-inverted-frame {
        fill: var(--clr-node-inverted-frame);
    }

    .node-fill-icon-secondary {
        fill: var(--clr-node-icon-secondary);
    }

    .node-fill-inverted-primary {
        fill: var(--clr-node-inverted-primary);
    }
</style>
